<template>
  <div 
    v-show="active"  
    id="edit-variable-modal" 
    :class="{'is-active': active}"
    class="ec-modal ec-variable-edit-modal"
    @click.self="closeModal">
    <div class="ec-modal-main is-loading animated fadeIn">
      <a 
        href="#" 
        class="close-icon modal-close"
        @click.stop.prevent="closeModal" /> 
      <div class="ec-modal-headline">{{ $t('modals.editable_variable.adjust_value') }}</div>
      <div class="ec-modal-form-wrapper">
        <div class="ec-edit-variable-range">
          <span v-if="variableData && variableData.min" :class="{'has-error': isSmallerThanMin}">{{ $t('modals.editable_variable.min') }}. {{ variableData.min }}</span>
          <span v-if="variableData && variableData.max" :class="{'has-error': isBiggerThanMax}">{{ $t('modals.editable_variable.max') }}. {{ variableData.max }}</span>
        </div>
        <input 
          id="edit-variable-modal-input"
          type="text"
          class="ec-modal-input"
          @keyup="castInput">
      </div>
      <div/>
      <div 
        v-show="orginalValue" 
        class="ec-modal-variable-orginal">
        <a 
          href="#" 
          @click.prevent="resetValue">Wert auf {{ orginalValue | numberFormater(orginalStateDecimals) }} zurücksetzen</a>
      </div>
      <div class="ec-modal-btn-wrapper">
        <button 
          id="ec-modal-variable-cancel" 
          class="ec-modal-btn-cancel btn is-grey modal-close" 
          @click="cancel">{{ $t('modals.editable_variable.cancel') }}</button> 
        <button 
          id="ec-modal-variable-ok" 
          :disabled="isBiggerThanMax || isSmallerThanMin"
          class="ec-modal-btn-ok btn is-blue"
          @click="ok">{{ $t('modals.editable_variable.save') }}</button>
      </div> 
      <div 
        v-show="loading" 
        class="ec-modal-loader"/>
    </div>
  </div>
</template>
<script>
import IMask from 'imask'
import {isNumber, isObject, toNumber, toString} from 'lodash'
import Modal from './Modal.mixin.vue'

export default {
  mixins: [Modal],
  data: function() {
    return {
      variable: null,
      loading: false,
      ref: null,
      inputMask: null,
      orginalValue: null,
      value: null,
      orginalState: null,
      orginalStateDecimals: 0,
      variableData: null,
      errors: {}
    }
  },
  watch: {
    'orginalStateDecimals': function(val) {
      let padFractionalZeros = false
      if(val) {
        padFractionalZeros = true
      }

      this.inputMask.updateOptions({
        scale: val,
        'padFractionalZeros': padFractionalZeros
      })
    },
    'variableData': function(data) {
      // this.inputMask.updateOptions({
      //   min: data.min,
      //   max: data.max,
      // })
    }
  },
  created() {
    this.$event.$on('change-variable', (payload, ref) => {
      this.variable = payload.variable
      this.orginalStateDecimals = payload.orginalStateDecimals
      this.ref = ref
      this.active = true
      this.orginalValue = payload.orginalValue
      this.errors = {}
      this.variableData = payload.variableData

      this.$nextTick(function() {
        this.$store.modalOpen = true
        this.value = payload.initValue
        this.inputMask.unmaskedValue = payload.initValue
        this.loading = false
      })
    })
  },
  mounted() {
    let element = document.getElementById('edit-variable-modal-input')

    this.inputMask = new IMask(element, {
      mask: Number,  // enable number mask  
      scale: 0,
      thousandsSeparator: '.',
      padFractionalZeros: false,
      signed: false,
      min: 0
    })
  },
  methods: {
    cancel() {
      this.closeModal()
    },
    ok() {
      this.loading = true
      let data = {}
      data[this.variable] = this.inputMask.unmaskedValue

      axios.post(this.$store.axiosBase+'variable/'+this.variable+'/update', {
          responses: { variables: data }
      }).then(() => {
        this.ref.value = this.inputMask.unmaskedValue
        this.$event.$emit('calculation-changed')
        this.closeModal()
      })
    },
    resetValue() {
      this.inputMask.unmaskedValue = toString(this.orginalValue)
    },
    castInput() {
      this.$nextTick(function() {   
        this.value = toNumber(this.inputMask.unmaskedValue)
      })
    },
  },
  computed: {
    isBiggerThanMax() {
      if(isObject(this.variableData) && isNumber(this.variableData.max) && isNumber(this.value)) {
        if(this.variableData.max < this.value) {
          return true
        }
      }

      return false
    },
    isSmallerThanMin() {
      if(isObject(this.variableData) && isNumber(this.variableData.min) && isNumber(this.value)) {

        if(this.variableData.min > this.value) {
          return true
        }
      }

      return false
    }
  }
}
</script>